export type ReimbursementCategoryPresetKey =
  | 'health_wellness'
  | 'work_from_home'
  | 'learning_development';

export interface ReimbursementCategoryPresetDefinition {
  key: ReimbursementCategoryPresetKey;
  label: string;
  spendCategories: string[];
}

export const REIMBURSEMENT_CATEGORY_PRESETS: ReimbursementCategoryPresetDefinition[] = [
  {
    key: 'health_wellness',
    label: 'Health & Wellness',
    spendCategories: ['Health & Wellness'],
  },
  {
    key: 'work_from_home',
    label: 'Work From Home',
    spendCategories: ['Work from Home Essentials', 'Mobile', 'Internet', 'Meal Delivery'],
  },
  {
    key: 'learning_development',
    label: 'Learning & Development',
    spendCategories: ['Learning & Development'],
  },
];
